import {Injectable} from '@angular/core';
import {moduloConciliacionBan} from '../../diccionarios/conciliacionBancariaModulo';
import {CommonService} from 'src/app/shared/utils/common.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {ParametrosCBM} from '../../models/conciliacionbancaria/parametrosCBM';


@Injectable({
  providedIn: 'root'
})
export class ParametroConciliacionBancariaPlusService {

  // params: any;
  diccionarioUrl: any;
  urlFinanzas: string;

  // urlDatosMaestros: string;

  constructor(private _commom: CommonService,
              private _util: UtilsService) {
    this.diccionarioUrl = moduloConciliacionBan.url.conciliacionBancaria;
    // this.urlDatosMaestros = this._util.getDatosMaestros();
    this.urlFinanzas = this._util.getFinanciero('');
    // this.params = moduloConciliacionBan.url.parametros;
  }

  getAll() {
    return this._commom.peticionGetConHeader(this.urlFinanzas + this.diccionarioUrl.conciBancparametro);
  }

  actualizarCampo(inObjeto: ParametrosCBM) {
    return this._commom.peticionPutConHeader(this.urlFinanzas + this.diccionarioUrl.conciBancparametro, inObjeto);
  }

  guardarParametros(inObjeto: ParametrosCBM) {
    return this._commom.peticionPostConHeader(this.urlFinanzas + this.diccionarioUrl.conciBancparametro, inObjeto);
  }

  deteleParametros(inIdBanco: string, inIdEmpresa: string) {
    return this._commom.peticionDeleteConHeader(this.urlFinanzas + this.diccionarioUrl.conciBancparametro + `?idBanco=${inIdBanco}&idEmpresa=${inIdEmpresa}`);
  }

  getSelectorArchivo(inIdEmpresa: string, inIdBanco: string) {
    return this._commom.peticionGetConHeader(this.urlFinanzas + this.diccionarioUrl.findFormatoplus + `?idBanco=${inIdBanco}&idEmpresa=${inIdEmpresa}`);
  }

  procesarArchivoSap(inObjet: any) {
    return this._commom.peticionPostConHeader(this.urlFinanzas + this.diccionarioUrl.uploadDocSAPplus, inObjet);
  }

  procesarArchivoCuerpo(inObjet: any) {
    return this._commom.peticionPostConHeader(this.urlFinanzas + this.diccionarioUrl.uploadDocplus, inObjet);
  }

  // getBancoPorEmpresa(inIdEmpresa: string) {
  //     // http://172.25.4.31:8081/qrks/v1/dmaestros/api/services/banco/pkEmpresa/444
  //     return this._commom.peticionGetConHeader(this.urlDatosMaestros + this.diccionarioUrl.banco + inIdEmpresa);
  // }

  // getAllEmpresa() {
  //     return this._commom.peticionGetConHeader(this.urlDatosMaestros + this.diccionarioUrl.empresa);
  // }


  //revisar esta funcion
  obtenerDatos(inIdBanco: string, inIdEmpresa: string) {
    // return this._commom.peticionGetConHeader(this.urlFinanzas + this.diccionarioUrl.obtenerConci +
    //     this.params.idempresa + inIdEmpresa + this.params.idBanco + inIdBanco);
  }


  // getCuentaPorBanco(inIdEmpresa: string, inIdBanco: string) {
  //     return this._commom.peticionGetConHeader(this.urlDatosMaestros + this.diccionarioUrl.bancoCuenta + inIdEmpresa + '/' + inIdBanco);
  // }


}
